import cart from '@ppcp/cart';
import {isPluginConnected} from '@ppcp/utils';
import {CheckoutGateway} from '../payments/classes';

if (isPluginConnected()) {
    const checkout = new CheckoutGateway(cart, {id: 'ppcp', context: 'checkout'});

    setInterval(() => {
        checkout.createButton();
    }, 2000);
}